// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"c3017dfe","275":"0c9c7718","861":"09f84d69","969":"7ef5d97b","986":"9eeb76fb"}[chunkId] + ".chunk.js";
};